import React from 'react'
import { Chart } from "react-google-charts";
import { graphql } from 'gatsby';
import SEO from '../components/SEO';
import Layout from '../components/layout'

const COLORS = ['#ff2800', '#faf500', '#35a16b', '#0041ff', '#66ccff', '#ff99a0', '#ff9900', '#9a0079', '#663300'];

const IdeologyPage = ({data}) => {
  return (
    <Layout>
      <SEO title='イデオロギーマップ'/>
      <h2>イデオロギーマップ</h2>
      <p>各会派の議案、請願への投票結果を解析し、各会派の政治思想的な距離感をマッピングしたものです。各軸の値というよりは、マップ上でのまとまりや距離感に着目してください。</p>
      <p>近い位置にマッピングされている会派は似たような投票をしている、つまり政治思想の傾向が(少なくとも投票の意思決定においては)近いと言えます。</p>
      <p>解析方法の<a href='https://blog.hokuma.net/visualization/pca_kashiwa_political_party/' rel='noopener noreferrer' target='_blank'>詳細</a></p>
      <div>
        <Chart
          chartType='ScatterChart'
          rows={data.internalIdeology.ideology.parties.map((party, i) => { 
            return [
              party.point[0],
              party.point[1],
              party.name,
              `color: ${COLORS[i]};`,
            ];
          })}
          columns={[
            {
              type: 'number',
              label: '',
            },
            {
              type: 'number',
              label: '',
            },
            {
              type: 'string',
              role: 'annotation'
            },
            {
              type: 'string',
              role: 'style' 
            },
          ]}
          options={
            // Chart options
            {
              title: 'イデオロギーマップ',
              hAxis: {
                title: '',
                viewWindow: { min: -6, max: 8 }
              },
              legend: 'none',
              vAxis: { title: "", viewWindow: { min: -2, max: 8 } },
            }
          }
          width={'100%'}
          height={'400px'}
          legendToggle
        />
      </div>
    </Layout>
  );
};

export default IdeologyPage;

export const query = graphql`
  query {
    internalIdeology {
      ideology {
        parties {
          name
          point
        }
      }
    }
  }
`;